<template>
  <div>
    <a-dropdown style="display: inline-block; height: 100%; vertical-align: initial">
      <span style="cursor: pointer">
        <!-- <a-avatar class="avatar" size="small" shape="circle" data-icon="user"/> -->
        <a-icon type="user" style="margin-right:4px" />
        <span>{{currUser}}</span>
        <a-icon type="down" style="margin-left:4px" />
      </span>
      <a-menu style="width: 150px" slot="overlay">
        <a-menu-item>
          <a @click="changePassword">
            <a-icon type="setting" />
            <span> 修改密码</span>
          </a>
        </a-menu-item>
        <a-menu-divider />
        <a-menu-item>
          <a @click="userloyout">
            <a-icon type="poweroff" />
            <span> 退出登录</span>
          </a>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <ChangePasswordModal ref="exportO" v-model="changePasswordModalShow" @done="uplist" />
  </div>
</template>

<script >
import { getUser } from "@/store";
import { logout } from "@/api/login";
import ChangePasswordModal from "./ChangePasswordModal.vue";
export default {
  data() {
    return {
      changePasswordModalShow: false,
    };
  },
  components: {
    ChangePasswordModal,
  },
  name: "HeaderAvatar",
  computed: {
    currUser() {
      const { name } = getUser();
      return name;
    },
  },
  methods: {
    userloyout() {
      logout();
      localStorage.removeItem("user");
      this.$router.push("/login");
    },
    changePassword() {
      this.changePasswordModalShow = true;
    },
    uplist() {
      logout();
      localStorage.removeItem("user");
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="less" scoped>
.avatar {
  margin: 20px 4px 20px 0;
  color: #1890ff;
  background: hsla(0, 0%, 100%, 0.85);
  vertical-align: middle;
}
</style>
